/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ShortMdSnapshotSide } from './shortMdSnapshotSide';

export interface ShortMdSnapshot {
  snapshotTime?: string;
  pairId?: number;
  bidEntriesInternal?: ShortMdSnapshotSide;
  askEntriesInternal?: ShortMdSnapshotSide;
}
